import React from "react";
const Cross = ({
  title,
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.667 2.815L9.48 8l5.186 5.185-1.482 1.482L8 9.48l-5.185 5.186-1.482-1.482L6.52 8 1.333 2.815l1.482-1.482L8 6.52l5.185-5.186z"
  }));
};
export default Cross;